// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1760075442203
      var cssReload = require("D:/App_php/cqjtdx/cqjtdx_student/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  